import React from 'react';
import Row from '../Row';
import Col from '../Col';
import FontAwesomeIcon from '../Icon';
import Attachment from '../Attachment';
import { useSelector } from "react-redux";
import TextareaAutosize from 'react-textarea-autosize';

const SendMessageBox = ({
  message,
  onSendMessage,
  onSetMessage,
  onSetAttachments,
  disabled
}) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <Row>
      <Col md={12} xs={12}>
        {
          user.roles[0].role.name !== "Realtor"?
          <div className='sendMessages'>
          {disabled &&
          <div className='sendMessages__sendIcon'
            onClick={onSendMessage}
          >
            <FontAwesomeIcon
              glyph="paper-plane"
              weight="light"
              size="small"
           />
          </div>}
          <div className='sendMessages__attachIcon'>
            <Attachment 
              icon={true}
              onSelect={(file) => onSetAttachments(file)} 
              files={[]}
            />
          </div>
      <TextareaAutosize
        className='autoincreasetextarea Sroll'
        minRows={2}
        maxRows={6}
        value={message}
        onChange={ev => onSetMessage(ev.target.value)}
        />
        </div>
        :(null)
        }
       
      </Col>
    </Row>
)
}

export default SendMessageBox;